import React from 'react'

export default class PopularCities extends React.Component
{
    constructor(props)
    {
        super(props)    

        this.env = this.props.env;
        this.cities = this.props.cities.length > 0 ? this.props.cities : [];
        this.cities.sort((a,b) => (a.state > b.state) ? 1 : ((b.state > a.state) ? -1 : 0));
    }

    render()
    {
        return(
            
            <div className="popular-cities mb-5">
                <div className="card">
                    <h3>Popular Cities for Dumpsters</h3>
                    <ul className="all-cities">
                        {
                            this.cities.map(city =>
                            {
                                return(
                                    <li><a href={'/'+city.url}>{city.place}</a></li>
                                )  
                            })
                        }
                    </ul>
                </div>
            </div>
        
        )
    }
    
}
